/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let SaOrgListUrl = root.sAdminsOrgUrl.link;
let SaAcOrgUserUrl = root.sAdminsOrgUserUrl.link;
let SaUserTaskUrl = root.sAdminsOrgUserTaskUrl.link;
import Vue from 'vue'
export default {
  state: {
    SaOrgListDataState:{},
    SaorgUserDetailsByIdState:{},
    SaUserTaskListState:{},
  },
  mutations: {
    getSaOrgListDataMut(state, value) {
      Vue.set(state, 'SaOrgListDataState', value);
    }, 
    getSaUserDetailsByIdMut(state, value) {
      Vue.set(state, 'SaorgUserDetailsByIdState', value);
    },
    getSaUserTaskMut(state, value) {
      Vue.set(state, 'SaUserTaskListState', value);
    }
  },
  actions: {
    // Get Organization List Details
    getSaOrgListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(SaOrgListUrl, payload).then(res => {
              context.commit('getSaOrgListDataMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    }, 
    // Update Account Organization Details By Id 
    updateSaAcOrgFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(SaOrgListUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Account USer Details
    createSaOrgUserFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(SaAcOrgUserUrl, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Org User Details
    getSaOrgUseDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(SaAcOrgUserUrl + payload.id + '/').then(res => {
              context.commit('getSaUserDetailsByIdMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Org User Details
    updateSaOrgUseDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(SaAcOrgUserUrl + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Remove Organization User Details
    removeSaOrgUserFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(SaAcOrgUserUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get User Task List
    getSaUserTaskListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(SaUserTaskUrl + payload.id + '/').then(res => {
              context.commit('getSaUserTaskMut', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    SaOrgListDataGetters: state => state.SaOrgListDataState,
    SaorgUserDetailsByIdGetters: state => state.SaorgUserDetailsByIdState,
    SaUserTaskListGetters: state => state.SaUserTaskListState
  }
}